import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type CrimeLinksIntegerFieldFragment = {
  __typename: 'IntegerField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type CrimeLinksFloatFieldFragment = {
  __typename: 'FloatField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type CrimeLinksEmailFieldFragment = {
  __typename: 'EmailField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  validationRegex?: string | null
}

export type CrimeLinksLongTextFieldFragment = {
  __typename: 'LongTextField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type CrimeLinksPlainTextFieldFragment = {
  __typename: 'PlainTextField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  validationRegex?: string | null
}

export type CrimeLinksUrlFieldFragment = {
  __typename: 'URLField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  validationRegex?: string | null
}

export type CrimeLinksDropdownFieldFragment = {
  __typename: 'DropdownField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  options: Array<string>
}

export type CrimeLinksMultiSelectFieldFragment = {
  __typename: 'MultiSelectField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  options: Array<string>
}

export type CrimeLinksPhoneNumberFieldFragment = {
  __typename: 'PhoneNumberField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type CrimeLinksFieldsSelectorFieldFragment = {
  __typename: 'FieldsSelectorField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  options: Array<string>
}

export type Crime_Links_Common_Field_CheckboxGroupField_Fragment = {
  __typename: 'CheckboxGroupField'
}

export type Crime_Links_Common_Field_DateField_Fragment = {
  __typename: 'DateField'
}

export type Crime_Links_Common_Field_DateTimeField_Fragment = {
  __typename: 'DateTimeField'
}

export type Crime_Links_Common_Field_DropdownField_Fragment = {
  __typename: 'DropdownField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  options: Array<string>
}

export type Crime_Links_Common_Field_EmailField_Fragment = {
  __typename: 'EmailField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  validationRegex?: string | null
}

export type Crime_Links_Common_Field_FieldsSelectorField_Fragment = {
  __typename: 'FieldsSelectorField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  options: Array<string>
}

export type Crime_Links_Common_Field_FileUploaderField_Fragment = {
  __typename: 'FileUploaderField'
}

export type Crime_Links_Common_Field_FloatField_Fragment = {
  __typename: 'FloatField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type Crime_Links_Common_Field_IntegerField_Fragment = {
  __typename: 'IntegerField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type Crime_Links_Common_Field_LongTextField_Fragment = {
  __typename: 'LongTextField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type Crime_Links_Common_Field_LookupField_Fragment = {
  __typename: 'LookupField'
}

export type Crime_Links_Common_Field_MultiSelectField_Fragment = {
  __typename: 'MultiSelectField'
}

export type Crime_Links_Common_Field_PhoneNumberField_Fragment = {
  __typename: 'PhoneNumberField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
}

export type Crime_Links_Common_Field_PlainTextField_Fragment = {
  __typename: 'PlainTextField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  validationRegex?: string | null
}

export type Crime_Links_Common_Field_RadioGroupField_Fragment = {
  __typename: 'RadioGroupField'
}

export type Crime_Links_Common_Field_TimeField_Fragment = {
  __typename: 'TimeField'
}

export type Crime_Links_Common_Field_UrlField_Fragment = {
  __typename: 'URLField'
  fieldId: string
  constFieldId: string
  name: string
  fieldType?: Types.FieldType | null
  placeholderText?: string | null
  validationRegex?: string | null
}

export type Crime_Links_Common_FieldFragment =
  | Crime_Links_Common_Field_CheckboxGroupField_Fragment
  | Crime_Links_Common_Field_DateField_Fragment
  | Crime_Links_Common_Field_DateTimeField_Fragment
  | Crime_Links_Common_Field_DropdownField_Fragment
  | Crime_Links_Common_Field_EmailField_Fragment
  | Crime_Links_Common_Field_FieldsSelectorField_Fragment
  | Crime_Links_Common_Field_FileUploaderField_Fragment
  | Crime_Links_Common_Field_FloatField_Fragment
  | Crime_Links_Common_Field_IntegerField_Fragment
  | Crime_Links_Common_Field_LongTextField_Fragment
  | Crime_Links_Common_Field_LookupField_Fragment
  | Crime_Links_Common_Field_MultiSelectField_Fragment
  | Crime_Links_Common_Field_PhoneNumberField_Fragment
  | Crime_Links_Common_Field_PlainTextField_Fragment
  | Crime_Links_Common_Field_RadioGroupField_Fragment
  | Crime_Links_Common_Field_TimeField_Fragment
  | Crime_Links_Common_Field_UrlField_Fragment

export const CrimeLinksMultiSelectFieldFragmentDoc = gql`
  fragment CrimeLinksMultiSelectField on MultiSelectField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
    options
  }
`
export const CrimeLinksIntegerFieldFragmentDoc = gql`
  fragment CrimeLinksIntegerField on IntegerField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
  }
`
export const CrimeLinksFloatFieldFragmentDoc = gql`
  fragment CrimeLinksFloatField on FloatField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
  }
`
export const CrimeLinksEmailFieldFragmentDoc = gql`
  fragment CrimeLinksEmailField on EmailField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
    validationRegex
  }
`
export const CrimeLinksLongTextFieldFragmentDoc = gql`
  fragment CrimeLinksLongTextField on LongTextField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
  }
`
export const CrimeLinksPlainTextFieldFragmentDoc = gql`
  fragment CrimeLinksPlainTextField on PlainTextField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
    validationRegex
  }
`
export const CrimeLinksUrlFieldFragmentDoc = gql`
  fragment CrimeLinksURLField on URLField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
    validationRegex
  }
`
export const CrimeLinksDropdownFieldFragmentDoc = gql`
  fragment CrimeLinksDropdownField on DropdownField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
    options
  }
`
export const CrimeLinksPhoneNumberFieldFragmentDoc = gql`
  fragment CrimeLinksPhoneNumberField on PhoneNumberField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
  }
`
export const CrimeLinksFieldsSelectorFieldFragmentDoc = gql`
  fragment CrimeLinksFieldsSelectorField on FieldsSelectorField {
    fieldId
    constFieldId
    name
    fieldType
    placeholderText
    options
  }
`
export const Crime_Links_Common_FieldFragmentDoc = gql`
  fragment Crime_Links_Common_Field on Field {
    ... on IntegerField {
      ...CrimeLinksIntegerField
    }
    ... on FloatField {
      ...CrimeLinksFloatField
    }
    ... on EmailField {
      ...CrimeLinksEmailField
    }
    ... on LongTextField {
      ...CrimeLinksLongTextField
    }
    ... on PlainTextField {
      ...CrimeLinksPlainTextField
    }
    ... on URLField {
      ...CrimeLinksURLField
    }
    ... on DropdownField {
      ...CrimeLinksDropdownField
    }
    ... on PhoneNumberField {
      ...CrimeLinksPhoneNumberField
    }
    ... on FieldsSelectorField {
      ...CrimeLinksFieldsSelectorField
    }
  }
  ${CrimeLinksIntegerFieldFragmentDoc}
  ${CrimeLinksFloatFieldFragmentDoc}
  ${CrimeLinksEmailFieldFragmentDoc}
  ${CrimeLinksLongTextFieldFragmentDoc}
  ${CrimeLinksPlainTextFieldFragmentDoc}
  ${CrimeLinksUrlFieldFragmentDoc}
  ${CrimeLinksDropdownFieldFragmentDoc}
  ${CrimeLinksPhoneNumberFieldFragmentDoc}
  ${CrimeLinksFieldsSelectorFieldFragmentDoc}
`
